import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { PaidService } from '@/__generated_graphql__/graphql';
import {
  ActivePaidService,
  MappedServiceType,
  SKELETON_COUNT_BY_TYPE
} from '@/components/AdvertisePayments/components/ExtraContent/ExtraContent.types';
import { ModalExtraContentServicePeriodList } from '@/components/AdvertisePayments/components/ExtraContent/ServicePeriodList';
import { useServicePeriodOptions } from '@/components/AdvertisePayments/hooks/useServicePeriodOptions';
import { ServicePeriodSkeleton } from '@/components/skeletons/AdvertisePaymentsSkeleton/ServicePeriodSkeleton';

import * as S from './ExtraContent.styles';

type ModalExtraContentServicePeriodProps = {
  serviceType: MappedServiceType;
  paidServices: PaidService[];
  activePeriodId: number | null;
  setActivePeriodId: (id: number) => void;
  setActivePaidServiceId: (id: ActivePaidService) => void;
  paidServicesLoading?: boolean;
};

export const ModalExtraContentServicePeriod: FC<
  ModalExtraContentServicePeriodProps
> = ({
  serviceType,
  activePeriodId,
  paidServices,
  paidServicesLoading,
  setActivePeriodId,
  setActivePaidServiceId
}) => {
  const { t } = useTranslation();

  const { periodItems, handleSelect } = useServicePeriodOptions({
    paidServices,
    serviceType,
    activePeriodId,
    setActivePeriodId,
    setSelectedServiceId: setActivePaidServiceId
  });

  if (paidServicesLoading) {
    const skeletonCount = SKELETON_COUNT_BY_TYPE[serviceType] ?? 4;

    return (
      <S.PlanSelectionCard>
        <S.PlanTitle>{t('Advertise.service_duration_label')}</S.PlanTitle>
        <ServicePeriodSkeleton count={skeletonCount} />
      </S.PlanSelectionCard>
    );
  }

  if (periodItems.length === 0) return null;

  return (
    <S.PlanSelectionCard>
      <S.PlanTitle>{t('Advertise.service_duration_label')}</S.PlanTitle>
      <ModalExtraContentServicePeriodList
        periodItems={periodItems}
        activePeriodId={activePeriodId}
        onSelect={handleSelect}
      />
    </S.PlanSelectionCard>
  );
};
